export default "__VITE_ASSET__BpsMx8lS__"